// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1652) return "static/chunks/1652-72c8c91fd58770b0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f","9363":"cff4c5fa"}[chunkId] || chunkId) + "." + {"6126":"caa644bd7779481d","7166":"874b3373c5ad15d5","7337":"f1ede546df3bd613","8445":"fc4292ebfa2ae67e","8848":"895439901bb5e2c9","9363":"d5bc67744e1c1e57","9584":"56a0a193302a56a4"}[chunkId] + ".js";
};